// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"900":"50424635","2222":"5c5673c2","4833":"3e991cb8","8317":"07a8d586","9514":"0a5d177f"}[chunkId] + ".chunk.css";
};